import React from "react"
import "./heading.scss"

const Heading = ({heading}) => {
  return <h2>{heading}</h2>
}

export default Heading
